var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#05616C ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#05616C ;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 43.5,
    y1: 9,
    x2: 43.5,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 12.04,
    x2: 43.5,
    y2: 12.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 18.02,
    x2: 43.5,
    y2: 18.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 24,
    x2: 43.5,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 29.98,
    x2: 43.5,
    y2: 29.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 35.96,
    x2: 43.5,
    y2: 35.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 10.24,
    y: 12.04,
    width: 27.53,
    height: 23.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.5,
    y1: 39,
    x2: 4.5,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 39,
    x2: 10.24,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 37.76,
    y1: 39,
    x2: 37.76,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 35.96,
    x2: 4.5,
    y2: 35.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 29.98,
    x2: 4.5,
    y2: 29.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 24,
    x2: 4.5,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 18.02,
    x2: 4.5,
    y2: 18.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.24,
    y1: 12.04,
    x2: 4.5,
    y2: 12.04
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.9c9ec40131e259e93abef03498a6ef54.svg";
export { ForwardRef as ReactComponent };